<template>
  <div class="layout-menu-add-on layout-menu-add-on-end relative flex-column">
    <div class="tag-line">Have a question<br />about the portal?</div>
    <Button
      label="FAQs"
      class="p-button-layout-menu p-button-sm p-button-rounded p-button-primary"
      icon="material-symbols-outlined quiz"
      @click="openFaq()"
    />
    <span class="layout-menuitem-tooltip p-tooltip">
      <span class="layout-menuitem-tooltip-arrow p-tooltip-arrow"></span>
      <span class="layout-menuitem-tooltip-text p-tooltip-text">FAQs</span>
    </span>
  </div>
</template>

<script setup>
  const openFaq = () => window.open("https://warehousequote.zendesk.com/hc/", "_blank", "noopener");
</script>